module.exports = __webpack_public_path__ + "static/media/tracker-4G.70d1ea71.png";